import React, { useContext, Fragment } from 'react';
import { Layout, Menu, Avatar } from 'antd';
import get from 'lodash/get';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { UserOutlined, TeamOutlined, RocketOutlined, BankOutlined } from '@ant-design/icons';
import { store } from '../utils/store';

import logo from '../assets/images/wingops-logo-blue.svg';

const { Header } = Layout;
const { SubMenu } = Menu;

const HeaderComponent = styled(Header)`
	padding: 0;
	display: flex;
	z-index: 9;
	background: #fff;
	border-bottom: 1px solid #f0f0f0;
`;

const RightMenu = styled(SubMenu)`
	border: none;
	.anticon.anticon-user {
		margin: 0;
	}
`;

const LogoContainer = styled.div`
	height: 64px;
	overflow: hidden;
`;

const Logo = styled.img`
	width: 168px;
	float: left;
	margin: 15px 20px 15px 24px;
	cursor: pointer;
`;

const RightMenuWrapper = styled.div`
	display: flex;
	border: none;
	justify-content: flex-end;
	flex: 1;
`;

const pathNamesMap: any = {
	'/': 'organizations',
	'/users': 'users',
	'/aircrafts': 'aircrafts',
};

function Head(props: any) {
	const { history } = props;
	const globalState = useContext(store);
	const { state, dispatch }: any = globalState;

	function getAvatar() {
		const avatarProps: any = {};
		const picture = get(state.userSelf, 'picture');

		if (picture) {
			avatarProps.src = picture;
		} else {
			avatarProps.icon = <UserOutlined />;
		}

		return <Avatar {...avatarProps} style={{ marginRight: 8 }} />;
	}

	return (
		<HeaderComponent theme="light">
			<LogoContainer>
				<Logo src={logo} />
			</LogoContainer>
			<Menu theme="light" selectedKeys={[pathNamesMap[window.location.pathname]]} mode="horizontal">
				<Menu.Item
					onClick={() => {
						window.location.href = '/';
					}}
					key="organizations"
					icon={<BankOutlined />}
				>
					Organizations
				</Menu.Item>
				<Menu.Item
					onClick={() => {
						history.push('/users');
					}}
					key="users"
					icon={<TeamOutlined />}
				>
					Users
				</Menu.Item>
				<Menu.Item
					onClick={() => {
						history.push('/aircrafts');
					}}
					key="aircrafts"
					icon={<RocketOutlined />}
				>
					Aircrafts
				</Menu.Item>
			</Menu>
			<RightMenuWrapper>
				<Menu selectedKeys={[]} mode="horizontal">
					<RightMenu
						key="right_menu"
						title={
							<Fragment>
								{getAvatar()}
								<span>{get(state.userSelf, 'name')}</span>
							</Fragment>
						}
					/>
				</Menu>
			</RightMenuWrapper>
		</HeaderComponent>
	);
}

export default withRouter(Head);
